import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import MainLayout from '@/views/layout/MainLayout.vue'
import Home from '@/views/Home.vue'
import ProductList from '@/views/product/ProductList.vue'
import UserManage from '@/views/system/User.vue'
import RoleManage from '@/views/system/Role.vue'
import DepartmentManage from '@/views/system/Department.vue'
import PositionManage from '@/views/system/Position.vue'
import DictManage from '@/views/system/Dict.vue'
import OutboundCreate from '@/views/outbound/Create.vue'
import SaleCreate from '@/views/sale/Create.vue'
import SaleOrder from '@/views/sale/Order.vue'
import ProductManage from '@/views/warehouse/Product.vue'
import CategoryManage from '@/views/warehouse/Category.vue'
import InboundManage from '@/views/warehouse/Inbound.vue'
import OutboundManage from '@/views/warehouse/Outbound.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: MainLayout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
          title: '首页',
          icon: 'el-icon-s-home'
        }
      },
      
      {
        path: '/sale',
        name: 'Sale',
        component: { render: h => h('router-view') },
        meta: {
          title: '销售管理',
          icon: 'el-icon-shopping-cart-full'
        },
        children: [
          {
            path: '/sale/create',
            name: 'SaleCreate',
            component: SaleCreate,
            meta: {
              title: '销售下单',
              icon: 'el-icon-shopping-cart-2'
            }
          },
          {
            path: '/sale/order',
            name: 'SaleOrder',
            component: SaleOrder,
            meta: {
              title: '销售订单',
              icon: 'el-icon-document'
            }
          },
          {
            path: '/sale/agent',
            name: 'Agent',
            component: () => import('@/views/sale/agent/index'),
            meta: { 
              title: '代理商管理',
              icon: 'el-icon-user-solid'
            }
          },
          
          {
            path: '/sale/dealer/:agentId',
            name: 'DealerManagement',
            component: () => import('@/views/sale/agent/DealerManagement'),
            meta: { 
              title: '经销商管理',
              icon: 'el-icon-user-solid',
              activeMenu: '/sale/agent'
            },
            hidden: true
          }
        ]
      },
      {
        path: '/system',
        name: 'System',
        component: { render: h => h('router-view') },
        meta: {
          title: '系统管理',
          icon: 'el-icon-setting'
        },
        children: [
          {
            path: '/system/user',
            name: 'User',
            component: UserManage,
            meta: {
              title: '用户管理',
              icon: 'el-icon-user'
            }
          },
          {
            path: '/system/role',
            name: 'Role',
            component: RoleManage,
            meta: {
              title: '角色管理',
              icon: 'el-icon-s-check'
            }
          },
          {
            path: '/system/department',
            name: 'Department',
            component: DepartmentManage,
            meta: {
              title: '部门管理',
              icon: 'el-icon-office-building'
            }
          },
          {
            path: '/system/position',
            name: 'Position',
            component: PositionManage,
            meta: {
              title: '岗位管理',
              icon: 'el-icon-s-custom'
            }
          },
          {
            path: '/system/dict',
            name: 'Dict',
            component: { render: h => h('router-view') },
            redirect: '/system/dict/index',
            meta: {
              title: '字典管理',
              icon: 'el-icon-notebook-2'
            },
            children: [
              {
                path: 'index',
                name: 'DictIndex',
                component: DictManage,
                meta: {
                  title: '字典类型',
                  icon: 'el-icon-notebook-1'
                }
              },
              {
                path: 'data/:dictId/:dictType/:dictName',
                name: 'DictData',
                component: () => import('@/views/system/DictData.vue'),
                meta: {
                  title: '字典数据',
                  icon: 'el-icon-notebook-2'
                }
              }
            ]
          },
          {
            path: '/system/menu',
            name: 'Menu',
            component: () => import('@/views/system/Menu.vue'),
            meta: { 
              title: '菜单管理',
              icon: 'el-icon-bank-card'
            }
          }
        ]
      },
      {
        path: '/process',
        component: { render: h => h('router-view') },
        name: 'ProcessManage',
        meta: {
          title: '流程管理',
          icon: 'el-icon-share'
        },
        children: [
          {
            path: '/process/ProcessFlow',
            name: 'ProcessFlow',
            component: () => import('@/views/process/ProcessFlow'),
            meta: { 
              title: '系统流程',
              icon: 'el-icon-connection'
            }
          },
          {
            path: '/process/ProcessNode/:id',
            name: 'ProcessNode',
            component: () => import('@/views/process/ProcessNode'),
            meta: { 
              title: '流程节点配置',
              icon: 'el-icon-setting',
              activeMenu: '/process/ProcessFlow'
            },
            hidden: true
          }
        ]
      },
      {
        path: '/purchase',
        component: { render: h => h('router-view') },
        name: 'Purchase',
        meta: { title: '采购管理', icon: 'el-icon-shopping-cart-full' },
        children: [
          {
            path: '/purchase/myplan',
            name: 'MyPlan',
            component: () => import('@/views/purchase/myplan/index'),
            meta: { 
              title: '我的计划', 
              icon: 'el-icon-document-checked'
            }
          },
          {
            path: '/purchase/plan',
            name: 'PurchasePlan',
            component: () => import('@/views/purchase/plan/index'),
            meta: { title: '采购计划', icon:'el-icon-shopping-cart-2'}
          },
          {
            path: '/purchase/plan/detail/:id',
            name: 'PlanDetail',
            component: () => import('@/views/purchase/plan/detail'),
            meta: { title: '计划详情', activeMenu: '/purchase/plan', icon:'el-icon-shopping-cart-1' },
            hidden: true
          },
          {
            path: '/purchase/order',
            name: 'PurchaseOrder',
            component: () => import('@/views/purchase/order/index'),
            meta: { title: '采购订单',icon:'el-icon-shopping-bag-1' }
          },
          {
            path: '/sale/dealer',
            component: () => import('@/views/sale/dealer/index'),
            name: 'Dealer',
            meta: { 
              title: '供应商管理', 
              icon: 'el-icon-user-solid' 
            }
          },
          {
            path: '/purchase/myorder',
            name: 'MyOrder',
            component: () => import('@/views/purchase/myorder/index'),
            meta: { 
              title: '我的订单', 
              icon: 'el-icon-document'
            }
          },
          {
            path: '/purchase/myplan/detail',
            name: 'PlanDetail',
            component: () => import('@/views/purchase/myplan/detail.vue'),
            meta: { title: '计划详情', icon:'el-icon-shopping-cart-1' }
          },
          {
            path: '/purchase/myorder/detail',
            name: 'OrderDetail',
            component: () => import('@/views/purchase/myorder/detail.vue'),
            meta: { title: '订单详情', icon: 'el-icon-document' }
          }
        ]
      },
      {
        path: '/warehouse',
        name: 'Warehouse',
        component: { render: h => h('router-view') },
        meta: {
          title: '仓库管理',
          icon: 'el-icon-house'
        },
        children: [
          {
            path: '/warehouse/product',
            name: 'Product',
            component: ProductManage,
            meta: {
              title: '商品管理',
              icon: 'el-icon-goods'
            }
          },
          {
            path: '/warehouse/category',
            name: 'Category', 
            component: CategoryManage,
            meta: {
              title: '类目管理',
              icon: 'el-icon-folder'
            }
          },
          {
            path: '/warehouse/inbound',
            name: 'Inbound',
            component: InboundManage, 
            meta: {
              title: '入库管理',
              icon: 'el-icon-download'
            }
          },
          {
            path: '/warehouse/outbound',
            name: 'Outbound',
            component: OutboundManage,
            meta: {
              title: '出库管理',
              icon: 'el-icon-upload2'
            }
          }
        ]
      },
      {
        path: '/finance',
        name: 'Finance',
        component: { render: h => h('router-view') },
        meta: { 
          title: '财务管理', 
          icon: 'el-icon-money' 
        },
        children: [
          {
            path: '/finance/payment',
            name: 'PaymentList',
            component: () => import('@/views/finance/payment/index.vue'),
            meta: { 
              title: '供应商付款',
              icon: 'el-icon-wallet'
            }
          },
          {
            path: '/finance/payment/records',
            name: 'PaymentRecords',
            component: () => import('@/views/finance/records.vue'),
            meta: { 
              title: '付款记录', 
              icon: 'el-icon-tickets' 
            }
          },
          {
            path: '/finance/mypayment',
            name: 'MyPayment',
            component: () => import('@/views/finance/mypayment/index'),
            meta: { 
              title: '我的付款申请',
              icon: 'el-icon-wallet'
            }
          }
        ]
      },
      {
        path: '/service',
        name: 'ServiceManage',
        component: { render: h => h('router-view') },
        meta: { 
          title: '客服管理',
          icon: 'el-icon-service'
        },
        children: [
          {
            path: '/service/complaint',
            name: 'ComplaintSystem',
            component: () => import('@/views/CustomerServiceForm.vue'),
            meta: {
              title: '投诉处理系统',
              icon: 'el-icon-message'
            }
          },
          {
            path: '/service/work-order-list',
            name: 'WorkOrderList',
            component: () => import('@/views/WorkOrderList.vue'),
            meta: {
              title: '我的工单',
              icon: 'el-icon-document'
            }
          },
          {
            path: '/service/all-orders',
            name: 'AllWorkOrders',
            component: () => import('@/views/AllWorkOrderList'),
            meta: { 
              title: '所有工单',
              icon:'el-icon-user-solid' 
            }
          }
        ]
      },
      {
        path: '/collection',
        component: { render: h => h('router-view') },
        name: 'Collection',
        meta: { title: '入账管理', icon: 'el-icon-money' },
        children: [
          {
            path: '/collection/register',
            name: 'CollectionRegister',
            component: () => import('@/views/acountAagerment/CollectionDetails.vue'),
            meta: { 
              title: '入账登记',
              icon: 'el-icon-money'
            }
          },
          {
            path: '/collection/supervisor-audit',
            name: 'SupervisorAudit',
            component: () => import('@/views/acountAagerment/SupervisorAudit.vue'),
            meta: {
              title: '主管审核',
              icon: 'el-icon-s-check'
            }
          },
          {
            path: '/collection/finance-audit',
            name: 'FinanceAudit', 
            component: () => import('@/views/acountAagerment/FinanceAudit.vue'),
            meta: {
              title: '财务审核',
              icon: 'el-icon-s-check'
            }
          },
          {
            path: '/collection/manager-audit',
            name: 'ManagerAudit',
            component: () => import('@/views/acountAagerment/ManagerAudit.vue'),
            meta: {
              title: '经理审核',
              icon: 'el-icon-s-check'
            }
          }
        ]
     },
     {
      path: '/dataManagement',
      component: { render: h => h('router-view') },
      name: 'DataManagement',
      meta: { 
        title: '数据管理', 
        icon: 'el-icon-share' 
      },
      children: [
        {
          path: '/dataManagement/data',
          name: 'Device',
          component: () => import('@/views/dataManagement/data.vue'),
          meta: { 
            title: '数据设备',
            icon: 'el-icon-sort-up'
          }
        }
      ]
     },

    {
      path: '/refund',
      name: 'refund',
      component: { render: h => h('router-view') },
      meta: { 
        title: '退款申请流程',
        icon: 'el-icon-money',
      },
      children: [
        {
          path: '/refund/payment-list',
          name: 'PaymentList',
          component: () => import('@/views/refund/PaymentList.vue'),
          meta: { 
            title: '支付列表',
            icon: 'el-icon-bank-card',
          }
        },
        {
          path: '/refund/requestRefund',
          name: 'requestRefund',
          component: () => import('@/views/refund/requestRefund.vue'), 
          meta: { 
            title: '申请退款',
            icon: 'el-icon-document',
           
          }
        },
        {
          path: '/refund/myApplications',
          name: 'myApplications',
          component: () => import('@/views/refund/myApplications.vue'),
          meta: { 
            title: '我的申请退款',
            icon: 'el-icon-document',
          }
        },
       
      
        {
          path: '/refund/godaddy',
          name: 'Godaddy',
          component: () => import('@/views/refund/godaddy.vue'),
          meta: { 
            title: '退款申请表',
            icon: 'el-icon-document',
            activeMenu: '/refund/payment-list'
          },
          hidden: true
        },
       
        {
          path: '/refund/supervisorReview',
          name: 'supervisorReview',
          component: () => import('@/views/refund/supervisorReview.vue'),
          meta: { 
            title: '主管审核',
            icon: 'el-icon-user-solid',
          }
        },
        {
          path: '/refund/managerReview',
          name: 'managerReview',
          component: () => import('@/views/refund/managerReview.vue'),
          meta: { 
            title: '经理审核',  
            icon: 'el-icon-user-solid',
          }
        },
        {
          path: '/refund/financialReview',
          name: 'financialReview',
          component: () => import('@/views/refund/financialReview.vue'),
          meta: { 
            title: '财务审核',
            icon: 'el-icon-user-solid',
            
          },
          
        },
        {
          path: '/refund/all-applications',
          name: 'AllRefundApplications',
          component: () => import('@/views/refund/AllApplications.vue'),
          meta: { 
            title: '所有申请退款',
            icon: 'el-icon-s-order',
          
          }
        },
      ]
    },

    // ICCID充值系统 - 收款管理
    {
      path: '/iccid-payment',
      name: 'IccidPayment',
      component: { render: h => h('router-view') },
      meta: {
        title: '收款管理',
        icon: 'el-icon-wallet'
      },
      children: [
        {
          path: '/iccid-payment/products',
          name: 'IccidProductList',
          component: () => import('@/views/iccid-product/index'),
          meta: {
            title: '商品管理',
            icon: 'el-icon-goods'
          }
        },
        {
          path: '/iccid-payment/products/:productCode/packages',
          name: 'IccidPackageList',
          component: () => import('@/views/iccid-package/index'),
          meta: {
            title: '套餐管理',
            icon: 'el-icon-box',
            activeMenu: '/iccid-payment/products'
          },
          hidden: true
        },
        {
          path: '/iccid-payment/agents',
          name: 'IccidAgentList',
          component: () => import('@/views/iccid-agent/index'),
          meta: {
            title: '店铺管理',
            icon: 'el-icon-office-building'
          }
        },
        // {
        //   path: '/iccid-payment/commissions',
        //   name: 'IccidCommissionList',
        //   component: () => import('@/views/iccid-commission/index'),
        //   meta: {
        //     title: '分佣管理',
        //     icon: 'el-icon-coin'
        //   }
        // },
        {
          path: '/iccid-payment/orders',
          name: 'IccidOrderList',
          component: () => import('@/views/iccid-order/index'),
          meta: {
            title: '订单管理',
            icon: 'el-icon-document'
          }
        },
        {
          path: '/iccid-payment/refund',
          name: 'IccidRefundList',
          component: () => import('@/views/iccid-refund/index'),
          meta: {
            title: '退款管理',
            icon: 'el-icon-money'
          }
        },
        {
          path: '/iccid-payment/qrcode',
          name: 'IccidQRCode',
          component: () => import('@/views/iccid-qrcode/index'),
          meta: {
            title: '缴费二维码',
            icon: 'el-icon-mobile-phone'
          }
        }
      ]
    }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  console.log('路由跳转:', to.path)
  next()
})

export default router 